export function setAdmin(admin){
    return {type:"SET_ADMIN", admin}
}

export function setAdminSelection(selection){
    return {type:"SET_SELECTION", selection}
}export function setAdminSessions(sessions){
    return {type:"SET_SESSIONS", sessions}
}